import { HttpClient, HttpMethod, HttpStatusCode } from '@hub-la/fe-core-http-client'
import { inject } from 'inversify'
import { UserVerificationTelegramStep } from '../domain/enums/user-verification-telegram-step'
import { GeneralError } from '../domain/errors/general'
import { Envs } from '../envs'

export class UpdateVerificationTelegramStepUseCase {
  public constructor(
    @inject(HttpClient)
    private readonly httpClient: HttpClient,
  ) {}

  public async execute(step: UserVerificationTelegramStep): Promise<void> {
    const response = await this.httpClient.request({
      method: HttpMethod.POST,
      url: `${Envs.FUNCTIONS_URL}/user/updateVerificationTelegramStep/pt`,
      body: { data: { step } },
    })

    if (response.statusCode === HttpStatusCode.OK || response.statusCode === HttpStatusCode.CREATED) {
      return response.data
    }

    throw new GeneralError()
  }
}
